import { BusinessRolePermission } from '../domain/index.js';
export const getEffectivePermissions = ({ userPermissions, rolePermissions, }) => {
    // Build effective permissions from roles
    const effective = new Set();
    for (const perm of rolePermissions.allow) {
        effective.add(perm);
    }
    for (const perm of rolePermissions.deny) {
        effective.delete(perm);
    }
    for (const perm of userPermissions.allow) {
        effective.add(perm);
    }
    for (const perm of userPermissions.deny) {
        effective.delete(perm);
    }
    return effective;
};
export const checkIfUserHasPermission = (effectivePermissions, permissions) => {
    if (!effectivePermissions || !permissions) {
        return false;
    }
    return permissions?.some((permission) => effectivePermissions?.has(permission));
};
export const BUSINESS_PERMISSION_LABELS = {
    [BusinessRolePermission.PaymentMethodRead]: 'View payment methods',
    [BusinessRolePermission.PaymentMethodCreate]: 'Add or manage payment methods',
    [BusinessRolePermission.PaymentMethodDelete]: 'Delete payment methods',
    [BusinessRolePermission.TransactionHistoryRead]: 'View transaction history',
    [BusinessRolePermission.TransactionReceiptRead]: 'View transaction receipts',
    [BusinessRolePermission.TransactionQuoteRead]: 'Get transaction quotes',
    [BusinessRolePermission.TransactionDepositCreate]: 'Initiate deposits',
    [BusinessRolePermission.TransactionWithdrawCreate]: 'Initiate withdrawals',
    [BusinessRolePermission.TransactionSwapCreate]: 'Perform asset swaps',
    [BusinessRolePermission.WalletBalancesRead]: 'View wallet balances',
    [BusinessRolePermission.RatesRead]: 'View exchange rates',
    [BusinessRolePermission.SettingsBusinessProfileRead]: 'View business profile settings',
    [BusinessRolePermission.SettingsTeamListRead]: 'View team member list',
    [BusinessRolePermission.SettingsTeamMemberInvite]: 'Invite new team members',
    [BusinessRolePermission.DeveloperApiKeyCreate]: 'Create API keys',
    [BusinessRolePermission.DeveloperApiKeyRead]: 'View API keys',
    [BusinessRolePermission.DeveloperApiKeyDelete]: 'Delete API keys',
    [BusinessRolePermission.DeveloperWebhookUrlUpdate]: 'Update webhook URLs',
    [BusinessRolePermission.DeveloperWebhookUrlRead]: 'View webhook URLs',
    [BusinessRolePermission.DeveloperIPWhitelistRead]: 'View IP whitelist',
    [BusinessRolePermission.DeveloperIPWhitelistUpdate]: 'Manage IP whitelist',
    [BusinessRolePermission.AdminExclusive]: 'Access admin-only features',
    [BusinessRolePermission.PaymentLinqRead]: 'View payment linqs',
    [BusinessRolePermission.PaymentLinqCreate]: 'Create payment linqs',
    [BusinessRolePermission.PaymentLinqUpdate]: 'Update payment linqs',
    [BusinessRolePermission.PaymentLinqDelete]: 'Archive payment linqs',
    [BusinessRolePermission.CheckoutLinkCreate]: 'Create checkout links',
    [BusinessRolePermission.CustomerRead]: 'View customers',
    [BusinessRolePermission.CustomerCreate]: 'Create customers',
    [BusinessRolePermission.CustomerUpdate]: 'Update customers and their KYC',
    [BusinessRolePermission.CustomerDelete]: 'Delete customers',
    [BusinessRolePermission.ComplianceKybSubmit]: 'Submit business verification (KYB)',
    [BusinessRolePermission.ComplianceKybRead]: 'View business verification (KYB) status',
    [BusinessRolePermission.PaymentBatchRead]: 'View payment batches',
    [BusinessRolePermission.PaymentBatchCreate]: 'Create payment batches',
    [BusinessRolePermission.PaymentBatchUpdate]: 'Update payment batches and their recipients',
    [BusinessRolePermission.PaymentBatchDelete]: 'Delete payment batches',
    [BusinessRolePermission.VirtualCardRead]: 'View virtual cards',
    [BusinessRolePermission.VirtualCardCreate]: 'Create virtual cards',
    [BusinessRolePermission.VirtualCardUpdate]: 'Freeze, unfreeze or change the PIN of virtual cards',
    [BusinessRolePermission.VirtualCardFund]: 'Load or unload virtual cards',
    [BusinessRolePermission.VirtualCardDelete]: 'Delete virtual cards',
    [BusinessRolePermission.MediaUpload]: 'Upload documents',
};
// Optional: Helper function for safe access
export const getPermissionLabel = (permission) => {
    return BUSINESS_PERMISSION_LABELS[permission];
};
//# sourceMappingURL=hasPermission.js.map